import React from 'react';
import {
  SettingsMenuContainer,
  SettingsMenuRow,
  SettingsMenuRowItem,
  SettingsMenuRowWrapper,
} from '../..';
import {
  IconArrowForward,
  IconServicesAvailableHours,
  IconServicesCustomCheckout,
  IconServicesOrderTiming,
  IconServicesWaitTimes,
  IconSystemCustomerAccounts,
  IconSystemGeneral,
  IconWrapperRounded,
} from '../../../../../../components/v2/icons';
import { useStores } from '../../../../../../../mobx/useStores';

export const PickUpServices = () => {
  const store = useStores();
  return (
    <SettingsMenuContainer>
      <SettingsMenuRow onClick={() => store.setActiveMobileMenu('general-pickup', 'pickup')}>
        <SettingsMenuRowWrapper>
          <SettingsMenuRowItem>
            <IconWrapperRounded className="icon-wrapper-rounded">
              <IconSystemGeneral />
            </IconWrapperRounded>
            <p>General</p>
            <IconArrowForward />
          </SettingsMenuRowItem>
        </SettingsMenuRowWrapper>
      </SettingsMenuRow>
      <SettingsMenuRow onClick={() => store.setActiveMobileMenu('order-timing', 'pickup')}>
        <SettingsMenuRowWrapper>
          <SettingsMenuRowItem>
            <IconWrapperRounded className="icon-wrapper-rounded">
              <IconServicesOrderTiming />
            </IconWrapperRounded>
            <p>Order Timing</p>
            <IconArrowForward />
          </SettingsMenuRowItem>
        </SettingsMenuRowWrapper>
      </SettingsMenuRow>
      <SettingsMenuRow onClick={() => store.setActiveMobileMenu('available-hours', 'pickup')}>
        <SettingsMenuRowWrapper>
          <SettingsMenuRowItem>
            <IconWrapperRounded className="icon-wrapper-rounded">
              <IconServicesAvailableHours />
            </IconWrapperRounded>
            <p>Available Hours</p>
            <IconArrowForward />
          </SettingsMenuRowItem>
        </SettingsMenuRowWrapper>
      </SettingsMenuRow>
      <SettingsMenuRow onClick={() => store.setActiveMobileMenu('wait-times-&-auto-statuses', 'pickup')}>
        <SettingsMenuRowWrapper>
          <SettingsMenuRowItem>
            <IconWrapperRounded className="icon-wrapper-rounded">
              <IconServicesWaitTimes />
            </IconWrapperRounded>
            <p>Wait Times & Auto Statuses</p>
            <IconArrowForward />
          </SettingsMenuRowItem>
        </SettingsMenuRowWrapper>
      </SettingsMenuRow>
      <SettingsMenuRow onClick={() => store.setActiveMobileMenu('custom-checkout-field', 'pickup')}>
        <SettingsMenuRowWrapper>
          <SettingsMenuRowItem>
            <IconWrapperRounded className="icon-wrapper-rounded">
              <IconServicesCustomCheckout />
            </IconWrapperRounded>
            <p>Custom Checkout Fields</p>
            <IconArrowForward />
          </SettingsMenuRowItem>
        </SettingsMenuRowWrapper>
      </SettingsMenuRow>
      <SettingsMenuRow onClick={() => store.setActiveMobileMenu('customer-info', 'pickup')}>
        <SettingsMenuRowWrapper>
          <SettingsMenuRowItem>
            <IconWrapperRounded className="icon-wrapper-rounded">
              <IconSystemCustomerAccounts />
            </IconWrapperRounded>
            <p>Customer Info</p>
            <IconArrowForward />
          </SettingsMenuRowItem>
        </SettingsMenuRowWrapper>
      </SettingsMenuRow>
    </SettingsMenuContainer>
  );
};
